var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multipane-resizer',[_c('div',{staticClass:"rounded flex-shrink-0 w-16 bg-gray-40 pointer-events-none",staticStyle:{"height":"2px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }